// extracted by mini-css-extract-plugin
export default {"projects":"Courses_projects__HWoVk","projectCard":"Courses_projectCard__x-ER1"};